import ApiService from "@/services/ApiService";
import { serialize } from '@/utils/helper';
export default {
  addHostRegister(data) {
    return ApiService().post("/hosts", data, true);
  },
  updateHost(data) {
    return ApiService().put("/hosts", data, true);
  },
  seekerSearchForm(data) {
    return ApiService().post("/hosts/search", data, true);
  },
  getDataPlayerFinder() {
    return ApiService().get('/hosts/me');
  },
  inactive() {
    return ApiService().put('/hosts/status/inactive');
  },
  active() {
    return ApiService().put('/hosts/status/active');
  }
};
